import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
export default function setLayer(component, button, classContent) {
  if (button) {
    button.addEventListener('click', function () {
      import(/* webpackChunkName: "layer" */"@mozaic-ds/freemarker/js/modules/_layer.js").then(function (module) {
        component.popinOffersList = new module["default"]({
          'classContent': classContent
        });
        component.popinOffersList.open();
      })["catch"](console.error);
    });
  }
}